import { LocationStatus } from '../../ts/enums';

export const STATION_STATUS = [
  { value: LocationStatus.all, label: 'All' },
  { value: LocationStatus.active, label: 'Active' },
  { value: LocationStatus.maintenance, label: 'Maintenance' },
  { value: LocationStatus.retired, label: 'Retired' },
  { value: LocationStatus.unassigned, label: 'Unassigned' },
];

// Map LocationStatus string to GraphQL state number
export const statusToStateNumber = (status: string): number | undefined => {
  switch (status) {
    case LocationStatus.active:
      return 1;
    case LocationStatus.maintenance:
      return 3;
    case LocationStatus.retired:
      return 4;
    case LocationStatus.unassigned:
      return 0;
    default:
      return undefined; // 'all' - no filter
  }
};

// Map sort key to GraphQL sort field
export const sortKeyToField = (key: string): string => {
  const sortMap: Record<string, string> = {
    name: 'NAME',
    state: 'STATE',
    configuration: 'CONFIGURATION',
    capacity: 'CAPACITY',
    available_hardware: 'AVAILABLE_HARDWARE_COUNT',
    totalHardware: 'TOTAL_HARDWARE_COUNT',
  };
  return sortMap[key] || 'NAME';
};
